import request from 'ynf-core-engine/request';
import { configHook } from '@utils';

/**
 * save
 * @param param0
 * @returns
*/
export async function save ({ params = {}, data = {}, ...rest } = {}) {
  /**
   * 默认查询参数
   */
  const defaultQuery = {
    params: {
      feV: 6,
      billId: '',
      mode: 'add' // mode: edit（编辑）、add（新增）
    },
    data: {
      /**
       * 1.默认data.data参数
       * 2.传入data.data参数
       */
      data: "{}"
    }
  };
  defaultQuery.params = configHook(params, defaultQuery.params);
  defaultQuery.data = configHook(data, defaultQuery.data);

  let dataDataJson = {
    _status: 'Insert'
  };
  try {
    if (typeof defaultQuery.data.data === 'string') {
      dataDataJson = JSON.parse(defaultQuery.data.data);
    } else {
      Object.assign(dataDataJson, defaultQuery.data.data)
    }
  } catch (err) {
  } finally {
    if (defaultQuery.params.mode === 'add') {
      dataDataJson['_status'] = 'Insert';
    } else {
      if (dataDataJson.id) {
        defaultQuery.params.billId = dataDataJson.id;
      }
      dataDataJson['_status'] = 'Update';
    }
  }
  defaultQuery.data.data = JSON.stringify(dataDataJson);

  try {
    const res = await request({
      url: `${_YPD_SERVICE_}/bill/save`,
      method: 'post',
      ...defaultQuery,
      ...rest
    });
    return res;
  } catch (err) {
    return Promise.reject(err);
  }
}

/**
 * save接口测试
*/
// require('./index.test').addTest(save);
// require('./index.test').editTest(save);
